import React, { useState } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  OSSSearchBar,
  OSSIcon,
  OSSButtonLink,
  OSSButton
} from "@oss/components";

const useStyles = makeStyles(theme => ({
  toolbar: {
    paddingBottom: theme.spacing(2)
  },
  sorting: {
    display: "flex",
    alignItems: "center"
  },
  sortingLabel: {
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap"
  }
}));

const OSSSearchAndFilterToolbar = ({
  title,
  paginationItems = null,
  sorting = null,
  hasSearch = null,
  hasFilters = null,
  filters,
  query,
  setQuery,
  showClearAll = false,
  hasFilterToggle = null,
  defaultQuery,
  searchBarProps = {},
  children
}) => {
  const classes = useStyles();
  const [showFilters, setShowFilters] = useState(true);
  return (
    <Toolbar className={classes.toolbar}>
      <Grid container spacing={1} alignItems="center" wrap="nowrap" justifyContent="space-between">
        {title && (
          <Grid item xs={12}>
            <Typography variant="h5">{title}</Typography>
          </Grid>
        )}
        {hasSearch && (
          <Grid item xs={12} md={4}>
            <OSSSearchBar
              query={query}
              setQuery={setQuery}
              {...searchBarProps}
            />
          </Grid>
        )}
        {hasFilterToggle && (
          <Grid item xs={6} md={4}>
            <OSSButton
              margin="dense"
              onClick={() => setShowFilters(!showFilters)}
              variant="contained"
              size="medium"
              disableElevation
              startIcon={<OSSIcon name="filter" />}
            >
              {showFilters ? "Hide" : "Show"} Filters
            </OSSButton>
          </Grid>
        )}
        {hasFilters && showFilters && (
          <Grid container item xs={12} spacing={1} md={10}>
            {filters.map(f => (
              <Grid
                item
                xs={6}
                sm={4}
                md={3}
                lg={2}
                key={f.key ? f.key : f.name}
              >
                <f.component
                  key={f.key ? f.key : f.name}
                  filter={f}
                  query={query}
                />
              </Grid>
            ))}
            {showClearAll && (
              <OSSButtonLink clickhandler={() => setQuery(defaultQuery)}>
                Clear All
              </OSSButtonLink>
            )}
          </Grid>
        )}
        {(paginationItems || sorting) && (
          <Grid
            container
            item
            xs={6}
            md={2}
            justify="flex-end"
            direction="column"
            alignItems="flex-end"
          >
            {paginationItems && <div>{paginationItems}</div>}
            {sorting && (
              <div className={classes.sorting}>
                <span className={classes.sortingLabel}>Sort:</span>
                {sorting}
              </div>
            )}
          </Grid>
        )}
        {children && (
          <Grid container item xs={12} md={4} display="flex" justifyContent="flex-end">
            {children}
          </Grid>
        )}
      </Grid>
    </Toolbar>
  );
};

export default OSSSearchAndFilterToolbar;
